import React from 'react'
import {IServiceFilterModel} from '../CarModel'
import DataTable, {TableColumn} from '../../../../shared/components/DataTable'

type Props = {
  data: IServiceFilterModel[]
  currentPage: number
  totalPages: number
  pageSize: number
  onPageSizeChange?: (size: number) => void 
  onPageChange: (page: number) => void // Düzeltme: parametre tipi eklendi
  onEdit?: (branch: IServiceFilterModel) => void // Düzeltme: Edit fonksiyonu eklendi
  onDelete?: (branch: IServiceFilterModel) => void // Düzeltme: Delete fonksiyonu eklendi
  sortBy?: string // Düzeltme: Sort state'leri eklendi
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const ServiceLogTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  pageSize,
  onPageSizeChange,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
  const branchColumns: TableColumn<IServiceFilterModel>[] = [
    {key: 'plate', label: 'Plaka', className: 'fw-semibold', sortable: true},
    {key: 'expenseName', label: 'Gider Adı', sortable: true},
    {key: 'serviceName', label: 'Servis Adı', sortable: true},
    {key: 'entryKm', label: 'Giriş KM', sortable: true},
    {key: 'exitKm', label: 'Çıkış KM', sortable: true},
    {key: 'serviceDescription', label: 'Servis Açıklama'},
    {key: 'date', label: 'Tarih', sortable: true},
    {key: 'entryDate', label: 'Giriş Tarihi', sortable: true},
    {key: 'entryTime', label: 'Giriş Saati'},
    {key: 'exitDate', label: 'Çıkış Tarihi', sortable: true},
    {key: 'exitTime', label: 'Çıkış Saati'},
  ]

  return (
    <DataTable
      data={data}
      columns={branchColumns}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Kayıt bulunamadı'
    />
  )
}
